import { ComponentValue } from '../sceneDataSchema';

export function booleanConverter(value: ComponentValue) {
  if (value === null) {
    return false;
  }

  if (typeof value === 'string') {
    switch (value) {
      case 'true':
        return true;
      case 'false':
        return false;
      default:
        return value;
    }
  }
  return value;
}
